import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import UnclaimedDraftEmbeddedSigning from "components/lib/Shared/ESignature/UnclaimedDraftEmbeddedSigning";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";
import { convertOfficialDetailsToSignerDetails } from "utils/esignature";

// Helper to get signer details for a given designation
const getSigners = (companyOfficials, designation) =>
  companyOfficials
    .filter(
      (official) =>
        official.designation === designation ||
        official.designation === "Director Shareholder"
    )
    .map(convertOfficialDetailsToSignerDetails);
/**
 * This component renders e-signature for different transactions
 * @returns
 */
const TransactionBRSEsignature = ({
  transaction,
  handleConfirmDetails,
  isLastStep,
}) => {
  // State for current signers and file URLs
  const [signers, setSigners] = useState([]);
  const [fileUrls, setFileUrls] = useState([]);
  let functionsToCall = [];
  if (isLastStep) {
    functionsToCall.push(handleConfirmDetails);
  }

  // Redux selectors for required data
  const transactionUnderReview = useSelector(
    (state) => state.transactionSlice.transactionUnderReview
  );
  const eSignatureFiles = transaction?.preSignedBusinessDocuments || {};
  const currentUser = useSelector((state) => state.userSlice);
  const companyOfficials = useSelector(
    (state) => state.companyOfficialsSlice.companyOfficials.items
  );

  const { company } = useSelector((state) => state.companySlice);
  const { contactPerson } = company;

  // Metadata for the signing process
  const metadata = {
    transactionId: transaction?._id,
    fileNames: Object.keys(eSignatureFiles),
    user: { _id: currentUser._id },
  };

  const allForms = Object.keys(eSignatureFiles).map((key) => key);
  // Update signers and file URLs when the selected tab or data changes
  useEffect(() => {
    if (contactPerson) {
      const signer = {
        name: contactPerson.fullName,
        emailAddress: contactPerson.emailAddress,
      };
      setSigners([signer]);
      setFileUrls(
        allForms.map(
          (form) =>
            `${process.env.REACT_APP_IMAGE_BASE_URL}/images/${eSignatureFiles[form]}`
        )
      );
    }
  }, []);

  // Render the signing UI if data is ready, otherwise show a loading spinner
  if (signers.length > 0 && fileUrls.length > 0) {
    return (
      <div>
        <UnclaimedDraftEmbeddedSigning
          signers={signers}
          fileUrls={fileUrls}
          metadata={metadata}
          functionsToCall={functionsToCall}
        />
      </div>
    );
  }

  return (
    <div>
      <h1>
        <SpinnerIcon /> Getting details ...
      </h1>
    </div>
  );
};

export default TransactionBRSEsignature;
